import { render, staticRenderFns } from "./SkeletonLoaderPageHead.vue?vue&type=template&id=ea86f8fa"
import script from "./SkeletonLoaderPageHead.vue?vue&type=script&lang=js"
export * from "./SkeletonLoaderPageHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports